module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/k8most-avatar-68c89e96f2e2a1cfd1874c3e6f423676.jpg";